var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenEyeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9983 3C17.3904 3 21.8764 6.87976 22.8169 12C21.8764 17.1202 17.3904 21 11.9983 21C6.60617 21 2.1202 17.1202 1.17969 12C2.1202 6.87976 6.60617 3 11.9983 3ZM11.9983 19C16.2339 19 19.8583 16.052 20.7757 12C19.8583 7.94803 16.2339 5 11.9983 5C7.76265 5 4.13827 7.94803 3.22083 12C4.13827 16.052 7.76265 19 11.9983 19ZM11.9983 16.5C9.51303 16.5 7.49831 14.4853 7.49831 12C7.49831 9.51472 9.51303 7.5 11.9983 7.5C14.4835 7.5 16.4983 9.51472 16.4983 12C16.4983 14.4853 14.4835 16.5 11.9983 16.5ZM11.9983 14.5C13.379 14.5 14.4983 13.3807 14.4983 12C14.4983 10.6193 13.379 9.5 11.9983 9.5C10.6176 9.5 9.49831 10.6193 9.49831 12C9.49831 13.3807 10.6176 14.5 11.9983 14.5Z",
    fill: "#3F3F47"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenEyeIcon);
export default __webpack_public_path__ + "static/media/open-eye-icon.75d78a9642f7fda985c319596509a8f0.svg";
export { ForwardRef as ReactComponent };